export const INVENTORY_STATUS_PRESENTATION = Object.freeze({
  in_stock: Object.freeze({
    label: "En stock",
    tone: "success",
  }),
  low_stock: Object.freeze({
    label: "Risque de rupture",
    tone: "warning",
  }),
  out_of_stock: Object.freeze({
    label: "Rupture",
    tone: "danger",
  }),
});


function normalizeNumber(value) {
  if (
    value === null
    || value === undefined
    || value === ""
  ) {
    return null;
  }

  const number = Number(value);

  return Number.isFinite(number)
    ? number
    : null;
}


export function formatInventoryQuantity(value) {
  const number = normalizeNumber(value);

  if (number === null) {
    return "—";
  }

  return new Intl.NumberFormat(
    "fr-FR",
    {
      maximumFractionDigits: 3,
    },
  ).format(number);
}


export function formatInventoryCoverage(value) {
  const number = normalizeNumber(value);

  if (number === null) {
    return "—";
  }

  return `${new Intl.NumberFormat(
    "fr-FR",
    {
      maximumFractionDigits: 1,
    },
  ).format(number)} j`;
}


export function formatInventoryDemand(value) {
  const number = normalizeNumber(value);

  if (number === null) {
    return "—";
  }

  return `${new Intl.NumberFormat(
    "fr-FR",
    {
      maximumFractionDigits: 2,
    },
  ).format(number)} / jour`;
}


export function getInventoryStatusPresentation(
  status,
) {
  return (
    INVENTORY_STATUS_PRESENTATION[status]
    || {
      label: "Statut inconnu",
      tone: "neutral",
    }
  );
}


export function getInventoryProductLabel(item) {
  const name = (
    typeof item?.product_name === "string"
    && item.product_name.trim()
  )
    ? item.product_name.trim()
    : "Produit sans nom";

  const reference = (
    typeof item?.product_reference === "string"
    && item.product_reference.trim()
  )
    ? item.product_reference.trim()
    : "";

  return reference
    ? `${name} — ${reference}`
    : name;
}


export function normalizeInventoryResponse(
  payload,
  defaultPageSize = 50,
) {
  return {
    items: Array.isArray(payload?.items)
      ? payload.items
      : [],
    pagination: {
      page: 1,
      page_size: defaultPageSize,
      total: 0,
      total_pages: 0,
      has_previous: false,
      has_next: false,
      ...(payload?.pagination || {}),
    },
    filters: payload?.filters || {},
  };
}
